import { useGetUserHotelsQuery } from "src/store/slices/client/client.api";
import { useOrdersList} from "../../../context/OrderListContext";
import OrderCard from "../../OrderCard/OrderCard";
import { RootState } from "src/store";
import { useSelector } from "react-redux";
import { STATUS_MAP, UNKNOWN_STATUS } from "../../../constants";
import { HOTEL_CARD_DATA_MAP, HOTEL_CARD_ICON } from "./constants";
import Tag from "src/components/Tag/Tag";
import Shell from "src/components/Shell/Shell";
import { formatDate } from "src/utility/time";
import { PaginationComponent } from "src/components";
import usePaginatedList from "../../../hooks/usePaginatedList";

export default function HotelsTransactions() {
  const { dateRange } = useOrdersList();
  const clientId = useSelector((state: RootState) => state.client.selectedClientId);
  const { data, isFetching, error } = useGetUserHotelsQuery(
    {
      dateFrom: dateRange?.[0].locale("en").format("YYYY-MM-DDTHH:mm:ss[Z]"),
      dateTo: dateRange?.[1].locale("en").format("YYYY-MM-DDTHH:mm:ss[Z]"),
      clientId,
    },
    { skip: !clientId || !dateRange },
  );
  const { pageItems, paginationProps } = usePaginatedList(data, `${dateRange?.[0].valueOf()}-${dateRange?.[1].valueOf()}`);

  return (
    <Shell loading={isFetching} error={error} data={data}>
      <div className="flex w-full flex-col gap-4">
        {pageItems?.map((hotel) => {
          const status = STATUS_MAP[hotel.orderStatus] ?? UNKNOWN_STATUS;
          const checkInOut =
            hotel.checkIn && hotel.checkOut
              ? `${formatDate(hotel.checkIn, "D MMMM YYYY")} - ${formatDate(hotel.checkOut, "D MMMM YYYY")}`
              : "—";
          const cardData = {
            icon: HOTEL_CARD_ICON,
            title: hotel.hotelName ?? "—",
            tag: <Tag label={status.label} color={status.color} className="rounded-full p-1 px-4 text-sm outline outline-current" />,
            data: {
              ...hotel,
              checkInOut,
              bookingStatusLabel: status.label,
            },
            id: hotel.referenceNumber ?? "",
          };
          return <OrderCard key={hotel.referenceNumber} cardData={cardData} dataMap={HOTEL_CARD_DATA_MAP} />;
        })}
        <PaginationComponent {...paginationProps} />
      </div>
    </Shell>
  );
}
